/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Flow_Stage_NoneInputs */

const en_task_flow_stage_none = /** @type {(inputs: Task_Flow_Stage_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doesn't move the case`)
};

const pt_br2_task_flow_stage_none = /** @type {(inputs: Task_Flow_Stage_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não move o caso`)
};

/**
* | output |
* | --- |
* | "Doesn't move the case" |
*
* @param {Task_Flow_Stage_NoneInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_stage_none = /** @type {((inputs?: Task_Flow_Stage_NoneInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Stage_NoneInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_stage_none(inputs)
	return pt_br2_task_flow_stage_none(inputs)
});